/* lua.js generated code 0.3.0 */
let HomeSceneBtn = require("clover/scene/component/homescene/HomeSceneButton")
let Events = require("cocos/framework/components/event")
let Button = xClass("GameClubButton", cc.Node, Events)

Button.prototype.ctor = function (btnLayer) {
    let self = this
    self.bind(self)
    cc.Node.prototype.ctor.call(self)
    self.btnLayer = btnLayer
    self.btns = table()
    self.init()
}
Button.prototype.init = function () {
    let self = this
    UIButton.create(self, true)
    PushBounceAnim.create(self)
    // self.on(UIButtonEvent.Click, function () {
    //     self.onClick()
    // })
    
    let bg = cc.Sprite.createWithSpriteFrameName("homeScene/icon_bg.png")
    self.setContentSize(bg.getContentSize())
    // self.setAnchorPoint(-0.5, 0.5)
    bg.setOpacity(255 * 0.7)
    self.addChild(bg, -1, "bg")
    // let icon = cc.Sprite.createWithSpriteFrameName("homeScene/activity_icon.png")
    // icon.setScale(0.9)
    // self.addChild(icon, 0, "icon")

    let text = cc.LabelTTF.create('游戏圈', FONT_DEF.microsoftYahei_24_blueStroke)
    self.addChild(text)
    self.initTips()
    self.text = text

    // FONT_DEF 创建的字体 得在 visit 的时候才会更新 _contentSize 这里延迟更新 text 的位置
    setTimeout(() => {
        let textSize = text.getContentSize()
        let height = -bg.getContentSize().height / 2 + textSize.height / 2 * 0.86
        if (META.platform === XcloverPlatform.wechatgame) {
            height -= textSize.height / 2
        }
        text.setPosition(0, height)
    }, 10);
}
Button.prototype.initTips = function () {
    let self = this
    let now = Localhost.timeInSec()
    let endTime = os.time({
        year: 2018,
        month: 7,
        day: 8,
        hour: 23,
        min: 59,
        sec: 59
    })
    if (now >= endTime ) {
        return
    }
    let tipsHeight = 75
    let bg = self.getChildByName("bg")
    let tips = cc.Sprite.create("cocos/gameClubActivityTips.png")
    self.addChild(tips, 0, "tips")
    tips.y = bg.getContentSize().height / 2 + tipsHeight / 2 - 10
    tips.runAction(cc.RepeatForever.create(cc.Sequence.create(
        cc.EaseSineInOut.create(
            cc.MoveBy.create(0.2, 0, 10)),
        cc.EaseSineInOut.create(
            cc.MoveBy.create(0.2, 0, -10)),
        cc.EaseSineInOut.create(
            cc.MoveBy.create(0.2, 0, 10)),
        cc.EaseSineInOut.create(
            cc.MoveBy.create(0.2, 0, -10)),
            cc.DelayTime.create(1)
    )))
}
module.exports = Button
